<template>
  <div id="app">
    <template v-if="$route.matched.length">
      <!--<keep-alive>-->
      <router-view ></router-view>
      <!--</keep-alive>-->
    </template>
    <template v-else>
      <div
        v-loading="loading"
        element-loading-text="Loading Your Content..."
        style="width: 100vw;height:100vh"
      ></div>
      <!--<p>{{$route}}</p>-->
    </template>
  </div>
</template>

<script>
  import authService from './utils/authService'
  import Loading from './components/Loading'

  export default {
    name: 'app',
    components: {
      Loading
    },
    data () {
      return {
        loggedIn: authService.isLogin(),
        spinnerMarginTop: 0,
        loading: true
      }
    }
  }
</script>

<style lang="less">
  /*@import './assets/css/bootstrap.min.css';*/
  @import './assets/less/variables.less';
  @import './assets/css/bootstrap.css';
  @import './assets/css/font-awesome.min.css';
  @import '~element-ui/lib/theme-chalk/index.css';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100vh;
    width:100vw;
    overflow: hidden;
  }
  .el-scrollbar__bar.is-vertical{
    /*width: 8px*/
  }
  .imgDialog{
    background-color: rgba(255,255,255,0);
    box-shadow: none;
  }
  .modal-blur {
    filter: blur(3px) brightness(100%);
  }
  .note-text .el-textarea__inner{
    border-top: none;
    border-bottom: none;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?9623cac6